import { CommonModule } from '@angular/common';
import { Component, Input, PipeTransform, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { TicketTable } from '../../../interfaces/ticket-table';
import { MatChipsModule } from '@angular/material/chips';
import { Router } from '@angular/router';
import { ConnectServerService } from '../../../../../services/connect-server.service';
import { Store } from '@ngrx/store';
import { UserState } from '../../../../../ngrx/user/user.reducer';


@Component({
  selector: 'app-ticket-table',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatChipsModule
  ],
  templateUrl: './ticket-table.component.html',
  styleUrl: './ticket-table.component.scss'
})
export class TicketTableComponent {
  currentLanguage: string = 'en';

  displayedColumns: string[] = ['idticket', 'progressive', 'ticket_date', 'description', 'ticketStatus'];
  dataSource = new MatTableDataSource<TicketTable>([]);
  filteredTickets: TicketTable[] = [];

  filterStatus = {
    open: true,
    closed: true
  };

  @Input() ticketList: TicketTable[] = [];
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private router: Router, private store: Store<{ user: UserState }>) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.ticketList.forEach((ticket) => {
        ticket.description = this.stripHtml(ticket.description);
      })
      this.dataSource.data = this.ticketList;
      this.filteredTickets = this.ticketList;
    }, 500);
    this.store.select(state => state.user.userInfo).subscribe(
      (val) => {
        this.currentLanguage = val?.lang_code ? val?.lang_code : 'en';
      }
    )
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;

    // Imposta il sortingDataAccessor per la colonna "openingDate" se necessario:
    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === 'ticket_date') {
        // Converti la stringa in data (timestamp) per ordinare correttamente
        return new Date(item.ticket_date).getTime();
      }
      return (item as any)[property];
    };
  }

  // Funzione per rimuovere i tag HTML
  private stripHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  onSelectionChange(event: any, type: number) {
    // Aggiorna lo stato del filtro in base al tipo selezionato
    if (type === 1) {
      this.filterStatus.open = event.selected;
    } else if (type === 2) {
      this.filterStatus.closed = event.selected;
    }

    // Esegue il filtraggio in base ai filtri attivi
    this.applyFilters();
  }

  applyFilters() {
    this.filteredTickets = this.ticketList;
    // console.log(this.filteredTickets)
    this.filteredTickets = this.ticketList.filter(ticket => {
      return (
        (this.filterStatus.open && ticket.ticketStatus?.type_status === 1) ||
        (this.filterStatus.closed && ticket.ticketStatus?.type_status === 2)
      );
    });

    // Aggiorna i dati della tabella Angular Material
    this.dataSource.data = this.filteredTickets;
  }

  goToTicket(id: number) {
    this.router.navigate(['ticketModify', id]);
  }

}
